import type { PluginObject } from 'vue';
import type { ICancelableNoticePayload } from '@/components/common/CancelableNotice/types';

import { events } from '@/components/common/CancelableNotice/utils';
import { NOTICE_EVENT } from '@/components/common/CancelableNotice/constants';

const CancelableNoticePlugin: PluginObject<ICancelableNoticePayload> = {
  install(Vue) {
    if (this.installed) return;

    this.installed = true;

    const notice = (params: ICancelableNoticePayload) => {
      return new Promise((resolve, reject) => {
        events.$emit(NOTICE_EVENT, { ...params, resolve, reject });
      });
    };

    Vue.prototype.$cancelableNotice = notice;
  },
};

export default CancelableNoticePlugin;
